// extracted by mini-css-extract-plugin
export default {"logoWrapper":"MlsLogo_logoWrapper__t2YoA","logoImg":"MlsLogo_logoImg__9o9Cz"};